import React, { useEffect, useContext, useState } from 'react'
import { useIsMobile } from '../../../utils/helpers'
import { FormattedMessage } from 'react-intl'
import SectionWithTag from '../../../components/SectionWithTag'
import PaddingContext from '../../../utils/PaddingContext'
import Image from '../../../components/Image'
import Button from '../../../components/Button/Button'
import { Color, Direction } from '../../../utils/constants'
import DetailsForm from '../../Applications/components/Segments/components/DetailsForm'
import api from '../../../utils/api'
import CK from 'js-cookie'
import { WP_REST_API_Post } from 'wp-types/index'

const id = 'page.epp.approaches'

const Approches = () => {
    const { padding } = useContext(PaddingContext)
    const isMobile = useIsMobile()

    const [formSubmitted, setFormSubmitted] = useState(false)
    const [openPost, setOpenPost] = useState<WP_REST_API_Post | null>(null)
    const redirectToLynxPage = () => {
        window.location.href =
      '/resources/application-note/rapid-improvement-of-enzyme-performance-with-lynx/'
    }

    useEffect(() => {
        const email = CK.get('application_note')
        setFormSubmitted(!!email)
    }, [openPost])

    const onClick = () => {
        if (formSubmitted) {
            redirectToLynxPage()
        }
        api
            .get('/wp-json/wp/v2/posts/?slug=rapid-improvement-of-enzyme-performance-with-lynx')
            .then(({ data }) => {
                setOpenPost(data[0])
            })
    }

    return (
        <div className='bg-white relative pt-12 md:p-0'>
            <div className='md:pt-30 relative'>
                <SectionWithTag
                    tag={{ id: `${id}.tag` }}
                    className='3xl:max-w-screen-2xl mx-auto'
                    padding={padding}
                >
                    <div className='max-w-[850px] mx-auto flex items-center py-10 md:p-0 text-center md:text-left'>
                        <FormattedMessage id={id} tagName='h2' />
                    </div>
                </SectionWithTag>
                <div className='side-padding'>
                    <div className='grid grid-cols-1 3xl:max-w-screen-2xl mx-auto'>
                        {isMobile ? (
                            <div className='max-w-[480px] mx-auto'>
                                <Image
                                    draggable={false}
                                    className='object-cover w-full h-full'
                                    alt='approaches'
                                    slug='approaches-mobile'
                                />
                            </div>
                        ) : (
                            <div className='max-w-[1080px] mx-auto md:pt-20 side-padding'>
                                <Image
                                    draggable={false}
                                    className='object-cover w-full h-full'
                                    alt='approaches'
                                    slug='approaches-desktop'
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div className='mt-12 md:mb-30 bg-purple md:bg-white'>
                    <div className='side-padding'>
                        <div className='py-10 md:bg-purple text-white md:px-10 md:py-8 md:max-w-[1160px] md:mx-auto'>
                            <div className='flex flex-col md:flex-row items-center md:justify-between text-center md:text-left gap-6'>
                                <div className='max-w-[650px]'>
                                    <FormattedMessage id={`${id}.cta.text`} tagName='h5' />
                                </div>
                                <div className='flex-shrink-0'>
                                    <Button
                                        buttonColor={Color.WHITE}
                                        isInverted
                                        chevron={Direction.RIGHT}
                                        outerClasses=''
                                        onClick={onClick}
                                    >
                                        <FormattedMessage id={`${id}.cta.button`} tagName='h6' />
                                    </Button>
                                </div>
                            </div>
                        </div>
                        {openPost && <DetailsForm close={() => setOpenPost(null)} post={openPost} />}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Approches
